import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_CHECKOUT_MEALS = 'GET_CHECKOUT_MEALS';
export const GET_CHECKOUT_MEALS_REQUEST = 'GET_CHECKOUT_MEALS_REQUEST';
export const GET_CHECKOUT_MEALS_RESPONSE = 'GET_CHECKOUT_MEALS_RESPONSE';
export const GET_CHECKOUT_MEALS_ERROR = 'GET_CHECKOUT_MEALS_ERROR';

export const getCheckoutMeals = menuSlug =>
  makeApiRequest({
    requestType: GET_CHECKOUT_MEALS,
    method: RequestService.getCheckoutMeals,
    params: { menuSlug },
  });
